import generatedProjects from "./generated.json";
import type { PublishedProject } from "../../portfolio/types";
import { sortProjectsForPortfolio } from "../../portfolio/projectOrdering";
import { assertValidPublishedProject } from "../../portfolio/validateProject";

const rawProjects = generatedProjects as PublishedProject[];

/** Validates and freezes the machine-generated catalog in stable-release-first portfolio presentation order. */
function createProjectCatalog(
  projects: PublishedProject[],
): readonly PublishedProject[] {
  for (const project of projects) {
    assertValidPublishedProject(project);
  }

  const ids = new Set<string>();
  for (const project of projects) {
    if (ids.has(project.id)) {
      throw new Error(`Duplicate project id "${project.id}".`);
    }
    ids.add(project.id);
  }

  return Object.freeze(sortProjectsForPortfolio(projects));
}

export const projects = createProjectCatalog(rawProjects);

/** Returns the generated publication projection for a route identifier, when present. */
export function findProject(projectId: string): PublishedProject | undefined {
  return projects.find((project) => project.id === projectId);
}
